import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';

import { getLanguage } from 'assets/languages';
import { queries } from 'api/api.constants';
import { GetSettingsResponse } from 'api/repositories/settings/settings.types';
import { Settings } from 'types/settings';
import { BRAND_DTO_ENUMS } from 'api/repositories/brand/brand.constants';
import useGetBrand from 'hooks/useGetBrand/useGetBrand';

const useGetSettings = () => {
  const { auth } = useSelector((state: any) => state.auth);
  const { preferences } = useSelector((state: any) => state.preferences);

  const { data: brand } = useGetBrand();

  return useQuery<GetSettingsResponse, Error, Settings>({
    ...queries.settings.getSettings({
      brandToken: auth.token,
    }),
    enabled: !!auth?.token && !!brand?.currency,
    select: (data) => {
      const serverLocale = process.env.LOCALE;
      const userLocale = getLanguage() ?? preferences.locale;
      const isJpy = brand?.currency === BRAND_DTO_ENUMS.CURRENCY.JPY;
      const isKrw = brand?.currency === BRAND_DTO_ENUMS.CURRENCY.KRW;
      const provider = isJpy
        ? BRAND_DTO_ENUMS.CURRENCY.JPY
        : BRAND_DTO_ENUMS.CURRENCY.KRW;

      const currencyMap = {
        [BRAND_DTO_ENUMS.CURRENCY.JPY]: {
          ko: '엔',
          ja: '円',
          default: { ko: '엔', ja: '円' },
        },
        [BRAND_DTO_ENUMS.CURRENCY.KRW]: {
          ko: '원',
          ja: 'ウォン',
          default: { ko: '원', ja: 'ウォン' },
        },
      };

      const currencyText =
        (isJpy || isKrw) && currencyMap[provider][userLocale]
          ? currencyMap[provider][userLocale]
          : currencyMap[provider].default[serverLocale] ||
            currencyMap[provider].default[preferences.locale];

      return { ...data?.data?.settings, currencyText };
    },
    staleTime: 1000 * 60, // 1분
    gcTime: 1000 * 60 * 5, // 5분
  });
};

export default useGetSettings;
